import { createClient } from '@libsql/client';

const db = createClient({
  url: import.meta.env.VITE_TURSO_DB_URL,
  authToken: import.meta.env.VITE_TURSO_AUTH_TOKEN
});

const DEFAULT_WHY_CHOOSE_US_CONTENT = {
  lastUpdated: new Date().toISOString(),
  title: "Why Choose Antacres?",
  subtitle: "We provide the best real estate experience with premium services and unmatched expertise",
  features: [
    {
      id: "verified-properties",
      title: "Verified Properties",
      description: "All properties are thoroughly verified and inspected for quality assurance."
    },
    {
      id: "secure-transactions",
      title: "Secure Transactions",
      description: "Safe and secure payment processes with complete transparency."
    },
    {
      id: "expert-guidance",
      title: "Expert Guidance",
      description: "Our experienced team of professionals guides you at every step of your journey."
    },
    {
      id: "tailored-solutions",
      title: "Tailored Solutions",
      description: "Customized services to meet your unique needs and preferences."
    },
  ],
};

async function ensureTableExists() {
  await db.execute(`
    CREATE TABLE IF NOT EXISTS why_choose_us_content (
      id TEXT PRIMARY KEY,
      content_data TEXT NOT NULL,
      updated_at TEXT NOT NULL
    );
  `);
}

async function getWhyChooseUsContent() {
  await ensureTableExists();
  try {
    const result = await db.execute({
      sql: 'SELECT content_data, updated_at FROM why_choose_us_content WHERE id = ?',
      args: ['why-choose-us'],
    });

    if (result.rows.length > 0) {
      const content = JSON.parse(result.rows[0].content_data);
      content.lastUpdated = result.rows[0].updated_at;
      return content;
    } else {
      console.log('No content found for Why Choose Us, returning default and saving it.');
      await createOrUpdateWhyChooseUsContent(DEFAULT_WHY_CHOOSE_US_CONTENT);
      return DEFAULT_WHY_CHOOSE_US_CONTENT;
    }
  } catch (error) {
    console.error("Error fetching Why Choose Us content:", error);
    throw new Error('Could not fetch Why Choose Us content from database.');
  }
}

async function createOrUpdateWhyChooseUsContent(content) {
  await ensureTableExists();
  const now = new Date().toISOString();
  try {
    const serializedContent = JSON.stringify({ ...content, lastUpdated: now });
    await db.execute({
      sql: `
        INSERT INTO why_choose_us_content (id, content_data, updated_at) VALUES (?, ?, ?)
        ON CONFLICT(id) DO UPDATE SET content_data = ?, updated_at = ?;
      `,
      args: [
        'why-choose-us',
        serializedContent,
        now,
        serializedContent,
        now
      ],
    });
    console.log('Why Choose Us content created or updated successfully!');
    return JSON.parse(serializedContent);
  } catch (error) {
    console.error("Error creating or updating Why Choose Us content:", error);
    throw new Error('Could not create or update Why Choose Us content in database.');
  }
}

export const whyChooseUsService = {
  getWhyChooseUsContent,
  createOrUpdateWhyChooseUsContent
};
